<template>
  <div class="Scale_classification">
    <div class="top">东南大学放松舱数据平台</div>

    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div style="width: 96%;margin-left:2%" class="left1">
            <ul class="leftul">
              <div style="width: 100%;height: 60px;text-align: center;line-height: 60px;color: #fff;font-weight: 700;font-size: 17px;">训练排名</div>

              <li v-for="(item,i) in getusetrainstatistic" :key="i">

                <div class="leftuldiv1">
                  <div class="leftuldiv2">
                    {{i+1}}
                  </div>
                </div>

                <div class="leftuldiv3">
                  {{item.userName}}
                </div>

                <div class="leftuldiv4">
                  {{item.testTimes}}次
                </div>

                <!-- <div class="leftuldiv5">
                  {{item.score}}分
                </div> -->
                
              </li>

            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <ul class="nav-ul">

            <li v-for="(item,i) in getdeviceuseinfostatistic" :key="i">
              <div style="height: 54px;width: 100%;line-height:64px;color: #fff;font-size: 18px;position: relative;">
                <span style="display: inline;margin-left:20px;text-align: left;">{{item.deviceName}}</span>
                <span v-if="item.status == '0'" style="position: absolute;top:0px;right: 20px;">已关闭</span>
                <span v-else style="position: absolute;top:0px;right: 20px;color: rgba(79, 219, 135, 1);">使用中</span>
              </div>

              <div style="height: 130px;width: 100%;margin-top:16px;">
                <div style="float: left;">
                  <img src="../../assets//太空舱.png" alt="" style="margin-left:20px">
                </div>

                <div style="width: 200px;margin-right:20px;margin-left:180px">
                  <ul style="height: 130px;width: 100%;">
                    <li style="width: 100%;position: relative;height: 40px;">
                      <img src="../../assets//使用人.png" alt="" style="position: absolute;top:0px;left:10px;">
                      <span style="color: #fff;position: absolute;top:0px;left:50px;width: 60px;">使用人：</span>
                      <span style="color: #fff;position: absolute;top:0px;left:110px;width: 60px;">{{item.userName?item.userName:'无'}}</span>
                    </li>
                    <li style="width: 100%;position: relative;height: 40px;"> 
                      <img src="../../assets//设备ID.png" alt="" style="position: absolute;top:0px;left:10px;">
                      <span style="color: #fff;position: absolute;top:0px;left:50px;width: 60px;">设备ID：</span>
                      <span style="color: #fff;position: absolute;top:0px;left:110px;width: 60px;">{{item.deviceKey}}</span>
                    </li>
                    <li style="width: 100%;position: relative;height: 40px;">
                      <img src="../../assets//运行时长.png" alt="" style="position: absolute;top:0px;left:10px;">
                      <span style="color: #fff;position: absolute;top:0px;left:50px;width: 70px;">运行时长： </span>
                      <span style="color: #fff;position: absolute;top:0px;left:116px;width: 60px;">  {{ item.useTimeSum}}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div style="height: 110px;">
                <div style="float: left;">
                  <p style="color: #fff;font-size: 18px;margin-left:20px;margin-top:10px">今日使用人数：<span style="color: rgba(0, 212, 138, 1)">{{item.userCount}}</span></p>
                  <p style="color: #fff;font-size: 18px;margin-left:20px;margin-top:20px">今日使用次数：<span style="color: rgba(0, 212, 138, 1)">{{item.deviceUseCount}}</span></p>
                </div>

                <div style="margin-left:170px;width: 150px;">
                  <p style="color: rgba(219, 205, 72, 1);font-size: 28px;margin-left:20px;margin-top:20px">{{item.useTimeAvg}}min</p>
                  <p style="color: #fff;font-size: 18px;margin-left:20px;margin-top:10px">平均使用时间</p>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div style="width: 96%;height: 320px;">

            <div style="height: 90px;width: 100%;position: relative;">
              <img style="width: 100%;height: 100%;" src="../../assets//右上框.png" alt="">
              <img src="../../assets//设备使用总次数.png" alt="" style="width: 60px;height: 60px;position: absolute;top:15px;left:40px">
              <p style="color: rgba(94, 207, 255, 1);position: absolute;top:15px;left:140px;font-size: 16px;">设备使用总次数</p>
              <p style="color: #fff;position: absolute;top:45px;left:140px;font-size: 26px;font-weight: 700;">{{getuseinfostatistic.deviceUseCount}}</p>
            </div>

            <div style="height: 90px;width: 100%;position: relative;">
              <img style="width: 100%;height: 100%;margin-top:20px" src="../../assets//右上框.png" alt="">
              <img src="../../assets//设备使用总人数.png" alt="" style="width: 60px;height: 60px;position: absolute;top:35px;left:40px">
              <p style="color: rgba(94, 207, 255, 1);position: absolute;top:35px;left:140px;font-size: 16px;">设备使用总人数</p>
              <p style="color: #fff;position: absolute;top:62px;left:140px;font-size: 26px;font-weight: 700;">{{getuseinfostatistic.userCount}}</p>
            </div>

            <div style="height: 90px;width: 100%;position: relative;">
              <img style="width: 100%;height: 100%;margin-top:45px" src="../../assets//右上框.png" alt="">
              <img src="../../assets//累计使用时长.png" alt="" style="width: 60px;height: 60px;position: absolute;top:60px;left:40px">
              <p style="color: rgba(94, 207, 255, 1);position: absolute;top:60px;left:140px;font-size: 16px;">累计使用时长</p>
              <p style="color: #fff;position: absolute;top:90px;left:140px;font-size: 26px;font-weight: 700;">{{getuseinfostatistic.useTimeSum}}</p>
            </div>
          </div>

          <div class="cskpcc">
            <div style="height: 9%;color: #fff;font-size: 18px;text-align: center;line-height: 50px;">设备列表</div>
            <div style="height: 50px;line-height: 50px;color: #fff;background-color: rgba(31, 100, 176, 1);width: 96%;margin-left:2%;margin-top:10px;position: relative;">

              <span style="position:absolute;top:0px;left: 5%; color: #fff;">名称</span>
              <span style="position:absolute;top:0px;left: 25%;color: #fff;">编号</span>
              <span style="position:absolute;top:0px;left: 45%;color: #fff;">联系人</span>
              <span style="position:absolute;top:0px;left: 65%;color: #fff;">联系电话</span>

            </div>

            <ul class="jcow">
              <li v-for="(item,i) in list" :key="i">
                <span style="position: absolute;top:0px;left: 5%; color: #fff;">{{item.deviceName}}</span>
                <span style="position: absolute;top:0px;left: 25%;color: #fff;">{{item.deviceKey}}</span>
                <span style="position: absolute;top:0px;left: 45%;color: #fff;">{{item.contactMan}}</span>
                <span style="position: absolute;top:0px;left: 65%;color: #fff;">{{item.contactTel}}</span>
              </li>
            </ul>
          </div>

        </div>
      </el-col>
    </el-row>

    <div class="bum">

    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        getusetrainstatistic:[],
        getdeviceuseinfostatistic:[],
        getuseinfostatistic:'',
        list:[],
      };
    },
    components:{

    },
    methods: {

    },
    mounted() {
      this.$Http_Post('capsule/deviceuserecord/getusetrainstatistic', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.getusetrainstatistic = res.Data;
        } else {

        }
      })
      this.$Http_Post('capsule/deviceuserecord/getdeviceuseinfostatistic', {useDate:this.Global.formatgetDate(new Date(), 'YYYY-MM-DD')}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.getdeviceuseinfostatistic = res.Data;
        } else {

        }
      })
      this.$Http_Post('capsule/deviceuserecord/getuseinfostatistic', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.getuseinfostatistic = res.Data;
        } else {

        }
      })
      this.$Http_Post('capsule/device/list', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.list = res.Data;
        } else {

        }
      })
    }
  };
</script>
<style>
.Scale_classification{width: 100%;height: 100%;background-color: #fff;background-image:url('../../assets//底部大背景.png');background-repeat: no-repeat;background-size: 100% auto;}
.Scale_classification .top{height: 80px;width: 100%;background-image:url('../../assets//顶部.png');background-repeat: no-repeat;background-size: 100% auto;text-align: center;font-size: 25px;line-height: 50px;color: #fff;font-weight: 700;margin-bottom: 10px;}
.Scale_classification .el-row{height: calc(100% - 120px);}
.Scale_classification .grid-content{height: 100%;}
[class*=el-col-] {height: 100%;}
.leftul li{height: 76px;width: 92%;background-color: rgba(22, 56, 105, 1);margin-top: 10px;position: relative;margin-left: 4%;}
.leftul li .leftuldiv1{height: 36px;width: 36px;border: 1px solid rgba(40, 127, 199, 1);position: absolute;top: 18px;left: 10px;}
.leftul li .leftuldiv2{height: 28px;width: 28px;background-color: rgba(40, 127, 199, 1);margin-left:4px;
margin-top:4px;color: #fff;text-align: center;line-height: 28px;}
.Scale_classification .left1{width: 96%;margin-left:2%;height: 100%; background-image:url('../../assets//左框.png');background-repeat: no-repeat;background-size: 100% 100%;}
.leftul li .leftuldiv3{position: absolute;top: 27px;left: 80px; font-size: 20px;color: #fff;font-family:serif}
.leftul li .leftuldiv4{position: absolute;top: 27px;left: 210px;font-size: 20px;color: #fff;font-family:serif}
.leftul li .leftuldiv5{position: absolute;top: 27px;right:30px; font-size: 20px;color: #fff;font-family:serif}
.leftul li:nth-child(2) .leftuldiv1{border: 1px solid rgba(255, 87, 51, 1);}
.leftul li:nth-child(2) .leftuldiv2{background-color: rgba(255, 87, 51, 1);}
.leftul li:nth-child(3) .leftuldiv1{border: 1px solid rgba(255, 195, 0, 1);}
.leftul li:nth-child(3) .leftuldiv2{background-color: rgba(255, 195, 0, 1);}
.leftul li:nth-child(4) .leftuldiv1{border: 1px solid rgba(67, 207, 124, 1);}
.leftul li:nth-child(4) .leftuldiv2{background-color: rgba(67, 207, 124, 1);}
.nav-ul{height: 100%;overflow: auto;}
.nav-ul::-webkit-scrollbar {width: 0;}
.nav-ul:hover::-webkit-scrollbar {width: 0px; }
.nav-ul::-webkit-scrollbar-thumb {background: #ccc;border-radius: 0px;}
.nav-ul::-webkit-scrollbar-track {background: #eee;border-radius:0px;}
.nav-ul>li{float: left;width: 49%;margin-left: 1%;height: 320px;margin-bottom: 15px;background-image:url('../../assets//中间部分框.png');background-repeat: no-repeat;background-size: 100% 100%;}
.cskpcc{width: 96%;height: calc(100% - 340px);margin-top: 15px;background-image:url('../../assets//右下框.png');background-repeat: no-repeat;background-size: 100% 100%;}
.jcow{width: 96%;margin-left: 2%;background-color: rgba(27, 65, 134, 1);}
.jcow li{height: 50px;width: 100%;border-bottom: 1px solid rgba(47, 83, 161, 1);position: relative;line-height: 50px;}
.bum{background-image:url('../../assets//底部.png');background-repeat: no-repeat;background-size: 100% auto;height: 40px;width: 100%;}
</style>